export const FETCH_COACH = 'FETCH_COACH';
export const PATCH_COACH = 'PATCH_COACH';
export const PATCH_COACH_PHONE = 'PATCH_COACH_PHONE';
export const WECHAT_BIND_COACH = 'WECHAT_BIND_COACH';
export const WECHAT_UNBIND_COACH = 'WECHAT_UNBIND_COACH';

export const RESET_AVAILABLE_DATES = 'RESET_AVAILABLE_DATES';
export const FETCH_AVAILABLE_DATES = 'FETCH_AVAILABLE_DATES';
export const FETCH_AVAILABLE_TIMES = 'FETCH_AVAILABLE_TIMES';



// WEBPACK FOOTER //
// ./src/store/coach/types.js